import React from 'react'
import './Wgbs.css'

import { FaChevronRight } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom';

function Wgbs() {
   const navigate = useNavigate();
    

  return (
    <section className='wgbs-sec'>
        <div className='container'>
            <h3>Why Choose Custom</h3>
            <h4>Software from 360 Gigabytes?</h4>
            <p className='plg'>
Client-specific fit, not compromise. Our custom solutions eliminate the limits of off-the-shelf tools by giving you ownership of functionality, data, and roadmap. Our cross-domain expertise ensures fast delivery, lower total cost of ownership, and software that grows with you.
</p>
            <p>Transform your operations with software built for your business. Contact us to start scoping your next custom platform.
            </p>

            <button className='btn-main' onClick={() => navigate('/contact')}><span>Contact Us</span> <FaChevronRight/></button>
        </div>

    </section>
  )
}

export default Wgbs
